<template>
  <b-row class="text-left">
    <b-col lg="4" xl="3">
      <label for="form-input">{{ label }}:</label>
    </b-col>
    <b-col lg="8" xl="9">
      <b-form-input v-if="editing" v-model="editedValue" class="mb-3" />
      <span v-else>{{ value }}</span>
    </b-col>
  </b-row>
</template>

<script>
import _ from 'lodash';
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    editing: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      editedValue: '',
      debouncedEmit: null
    };
  },
  methods: {
    emitValue() {
      this.$emit('valueChanged', this.editedValue);
    }
  },
  mounted() {
    this.editedValue = this.value;
    this.debouncedEmit = _.debounce(this.emitValue, 500);
  },
  watch: {
    editedValue: {
      handler(value) {
        this.debouncedEmit();
      }
    }
  }
};
</script>

<style></style>
